import { Icon, PrimaryButton, DefaultButton } from '@fluentui/react';
import { useFileBrowserStore } from '@/hooks';

/**
 * Mobile email save mode. Shown only when an open email has been captured
 * (mobile read-surface "Save to FileSpace" button). The user browses to a
 * destination folder, then taps Save here or Cancel. Reuses the normal file
 * browser for navigation; this is just a persistent action bar on top.
 */
export function SaveBar() {
  const { saveEmail, isSavingEmail, currentPath, saveCurrentEmailHere, cancelSaveMode } =
    useFileBrowserStore();

  if (!saveEmail) return null;

  const folder = currentPath
    ? currentPath.replace(/\/+$/, '').split('/').pop() || 'site root'
    : 'site root';

  return (
    <div className="save-bar">
      <div className="save-bar-info">
        <Icon iconName="Mail" className="save-bar-icon" />
        <div className="save-bar-text">
          <span className="save-bar-subject" title={saveEmail.subject}>
            {saveEmail.subject}
          </span>
          <span className="save-bar-dest">Save to: {folder}</span>
        </div>
      </div>
      <div className="save-bar-actions">
        <DefaultButton text="Cancel" onClick={cancelSaveMode} disabled={isSavingEmail} />
        <PrimaryButton
          text={isSavingEmail ? 'Saving' : 'Save here'}
          iconProps={{ iconName: 'Save' }}
          onClick={saveCurrentEmailHere}
          disabled={isSavingEmail}
        />
      </div>
    </div>
  );
}
